<template>
    <div class="elementary-section" v-bind:class="{'elementary-section--has-shadow': shadow, 'bg--light': light}">
        <div class="elementary-section__in">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:  'ElementarySection',
    props: {
        shadow: {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        light:  {
            type:     Boolean,
            required: false,
            default:  () => false,
        }
    }
}
</script>
